<template>
  <div class="header-inner">
    <div class="logo">
      <span class="logo-mark">S</span>
      <span class="logo-text">三三支付</span>
    </div>
    <div class="user-actions">
      <el-dropdown>
        <span class="el-dropdown-link">
          你好，{{ username || '管理员' }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item>个人信息</el-dropdown-item> -->

          <el-dropdown-item @click.native="openPasswordDialog">修改密码</el-dropdown-item>
          <el-dropdown-item divided @click.native="openLogoutDialog">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>

    <el-dialog title="退出登录" :visible.sync="logoutDialogVisible" width="360px">

      <div>确认退出当前账号吗？</div>
      <div slot="footer">
        <el-button @click="logoutDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmLogout">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="420px">
      <el-form label-width="110px">
        <el-form-item label="旧密码">
          <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入旧密码" />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" />
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmPasswordChange">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      logoutDialogVisible: false,
      passwordDialogVisible: false,
      username: '',
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  computed: {},
  mounted() { },
  created() {

  },
  methods: {
    openLogoutDialog() {
      this.logoutDialogVisible = true;
    },
    confirmLogout() {
      this.logoutDialogVisible = false;
      this.$http_get('/admin/login/logout').then(res => {
        localStorage.removeItem('tokena')
        this.$router.push("/login");
      })

    },
    openPasswordDialog() {
      this.passwordForm.oldPassword = "";
      this.passwordForm.newPassword = "";
      this.passwordForm.confirmPassword = "";
      this.passwordDialogVisible = true;
    },
    confirmPasswordChange() {
      if (
        !this.passwordForm.oldPassword ||
        !this.passwordForm.newPassword ||
        !this.passwordForm.confirmPassword
      ) {
        this.$message.warning("请完整填写密码");
        return;
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message.error("两次输入的新密码不一致");
        return;
      }
      this.$http_post('/admin/account/change_password', {
        old_password: this.passwordForm.oldPassword,
        new_password: this.passwordForm.newPassword
      }, 1).then(res => {
        if (res && res.code === 200) {
          this.passwordDialogVisible = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  letter-spacing: 1px;
}

.logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #f7c84b;
  color: #101826;
  font-weight: 700;
}

.logo-text {
  font-size: 16px;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
}
</style>
